/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dashboard_Driver_Available_Orders_CountInputs */

const vi_dashboard_driver_available_orders_count = /** @type {(inputs: Dashboard_Driver_Available_Orders_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} đơn chưa có tài xế`)
};

/**

* @param {Dashboard_Driver_Available_Orders_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_available_orders_count = /** @type {((inputs: Dashboard_Driver_Available_Orders_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_Available_Orders_CountInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_available_orders_count(inputs)
});